export default "__VITE_ASSET__CyPPg6aj__"